import { CommonApiTypes } from 'models/Common/commonApiTypes';
import { IDDiagnosis } from 'models/DCK/basicInterface';

export interface VerifyVoucherCodeApiResopnse extends CommonApiTypes {
    data: VoucherDataType;
    error?: {
        code: number;
        message: string;
    };
}

export interface VoucherDataType {
    hospitalId: string;
    token: string;
    voucher: {
        code: string;
        description: string;
        status: number;
        timestamp: number;
        type: number;
        usedTimestamp: number;
        _id: string;
        __v: number;
    };
    diagnosis?: IDDiagnosis;
}

export interface VerifyVoucherCodeType {
    code: string;
}

export enum VerifyVoucherCodeError {
    NOT_FOUND = 1001,
    ALREADY_EXPIRED = 1003,
}
